import { Loader } from "@campgladiator/cgui-core.atoms.loader";
import React from "react";
import { UpgradeMembershipModalProps } from "../../UpgradeMembershipModal";
import { ProductHeading } from "../ProductHeading";
import styles from "./SelectType.module.scss";

export type SelectTypeProps = { isPriceLoading: boolean } & Pick<
  UpgradeMembershipModalProps,
  "productName" | "productPrice"
>;

const SelectType = ({
  productName,
  productPrice,
  isPriceLoading,
}: SelectTypeProps) => {
  const isLoading = !productName || !productPrice || isPriceLoading;
  return (
    <>
      {isLoading ? (
        <Loader className={styles.loader} />
      ) : (
        <ProductHeading productName={productName} productPrice={productPrice} />
      )}
    </>
  );
};

export default SelectType;
